// extracted by mini-css-extract-plugin
module.exports = {"notfound_container":"NotFound_notfound_container__1utZF","error_button":"NotFound_error_button__17au2"};